import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../../assets/css/mainMenu.css";
import "../../../assets/css/addunit.css";

import edit from "../../../assets/icons/edit.svg";
import close from "../../../assets/icons/close.svg";
import ArrowDown from "../../../assets/icons2/ArrowDown.svg";
import trash from "../../../assets/icons/trash.svg";
import ArrowUp from "../../../assets/icons2/ArrowUp.svg";
import plus1 from "../../../assets/icons/plus1.svg";
import search2 from "../../../assets/icons/search2.svg";

import Loader from "../../../Components/LoaderAndSpinner/Loader";
import fetchWrapper from "../../../AuthMiddleware/FetchWrapper";
import Pagination from "../../../Components/Pagination/Pagination";
import { hasPermission } from "../../../Services/authUtils";

const AssetList = () => {
  const [loading, setLoading] = useState(false);
  const [modelList, setModelList] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionAssetId, setActionAssetId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const navigate = useNavigate();
  const { id } = useParams();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchAssets(); // Perform search
    }
  };

  useEffect(() => {

    fetchAssets();
  }, [
    id,
    page,
    pageSize,
    sortBy,
    // search,
    totalPages,
    currentPage,
    totalItems,
    confirmModal,
  ]);

  const fetchAssets = async () => {
    const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}`;

    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/model/paginate${queryString}`,
        {
          method: "POST",
        },
        navigate
      );

      setModelList(data.models);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);

    } catch (error) {
      toast.error(`Error fetching models Lists: ${error.message}`);
      console.error("Error fetching models Lists:", error);
    }
  };
  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const handleToggleUserStatus = (assetId) => {
    setActionAssetId(assetId);
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/model/delete/${actionAssetId}`;

    try {
      await fetchWrapper(url, { method: "POST" }, navigate);

      setLoading(false);
      setConfirmModal(false);
      toast.success("Model Delete Successful");
    } catch (error) {
      setLoading(false);
      toast.error(`Error deleting model: ${error.message}`);
      console.error("Error deleting model:", error);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
      // Add any additional logic for page change here
    }
  };

  // Calculate the page numbers to display
  const getPageNumbers = () => {
    let startPage, endPage;
    if (totalPages <= 5) {
      // If there are 5 or fewer total pages, show all of them
      startPage = 1;
      endPage = totalPages;
    } else if (currentPage <= 3) {
      // If the current page is near the beginning, show the first 5 pages
      startPage = 1;
      endPage = 5;
    } else if (currentPage + 2 >= totalPages) {
      // If the current page is near the end, show the last 5 pages
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      // Otherwise, show 2 pages before and 2 pages after the current page
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="container">
            <div className="show-breadcrumb pt-3">
              <div className="">
                <h5>Model Class</h5>

                <nav className="breadcrumb-nav" aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a className="">Models</a>
                    </li>

                    <li className="breadcrumb-item active" aria-current="page">
                      Model Class
                    </li>
                  </ol>
                </nav>
                <div className="">
                  <div
                    className="navbar-3 d-flex justify-content-between"
                    style={{ marginTop: "-3px" }}
                  >
                    <div className="search-container ">
                      <img src={search2} alt="Search" />
                      <input
                        type="text"
                        className=""
                        id="search"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search "
                      />
                    </div>

                    {hasPermission(["models.create"]) && (
                      <div className="">
                        <button
                          type="button"
                          id="openPopup"
                          className="btn-bg"
                          onClick={() => navigate(`/model_class/create`)}
                        >
                          <span className="plus-icon">
                            <img src={plus1} alt="Plus Icon" />
                          </span>
                          CREATE NEW MODEL CLASS
                        </button>
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: "-10px" }}>
                    <div className="table-responsive">
                      <table className="table  align-middle table-text">
                        <thead className="table-head align-middle">
                          <tr>
                            {/* <th className="table-check">
                              <input type="checkbox" />
                            </th> */}
                            <th>ID</th>
                            <th
                              className="col text-uppercase"
                              onClick={() => handleSortChange("model_code")}
                            >
                              Model Class Code{" "}
                              {sortBy.field === "model_code" && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="ArrowUp" />
                                  ) : (
                                    <img src={ArrowDown} alt="ArrowDown" />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="col text-uppercase"
                              onClick={() => handleSortChange("model_name")}
                            >
                              Model Class Name{" "}
                              {sortBy.field === "model_name" && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="ArrowUp" />
                                  ) : (
                                    <img src={ArrowDown} alt="ArrowDown" />
                                  )}
                                </span>
                              )}
                            </th>
                            {(hasPermission(["models.update"]) ||
                              hasPermission(["models.delete"])) && (
                                <th className="col-2 text-uppercase">ACTION</th>
                              )}
                          </tr>
                        </thead>
                        <tbody className="pl-4">
                          {modelList.map((model, rowIndex) => (
                            <tr key={model._id}>
                              {/* <td className="table-check">
                                <input type="checkbox" />
                              </td> */}
                              <td>{rowIndex + startIndex}</td>
                              <td className="col">{model.model_code}</td>
                              <td className="col">{model.model_name}</td>

                              {(hasPermission(["models.update"]) ||
                                hasPermission(["models.delete"])) && (
                                  <td>
                                    <div className="action-icons d-flex justify-content-left align-items-center ">
                                      {hasPermission(["models.update"]) && (
                                        <button
                                          style={{
                                            border: "none",
                                            backgroundColor: "transparent",
                                          }}
                                          className="align-content-center me-3"
                                          onClick={() =>
                                            navigate(`/model/edit/${model._id}`)
                                          }
                                        >
                                          <img src={edit} alt="edit" />
                                        </button>
                                      )}

                                      {hasPermission(["models.delete"]) && (
                                        <button
                                          style={{
                                            border: "none",
                                            backgroundColor: "transparent",
                                          }}
                                          className="align-content-center"
                                          onClick={() =>
                                            handleToggleUserStatus(model._id)
                                          }
                                        >
                                          <img src={trash} alt="trash" />
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                    totalItems={totalItems}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            </div>

            {/* Confirmation Modal */}
            <div
              id="overlay"
              className={`modal fade ${confirmModal ? "show" : ""}`}
              tabIndex="-1"
              role="dialog"
              style={{
                zIndex: 30,
                display: confirmModal ? "block" : "none",
                transition: "width 2s",
              }}
            >
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Delete asset</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setConfirmModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="addunit-form">
                    <p>Are you sure you want to delete this asset?</p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={confirmAction}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default AssetList;
